import './NavBar.scss';
import { Link } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { store } from "../state";
import { setAddress, setProvider, setNetworkId, fetchBalance, setIsConnecting, fetchDelegates } from "../state/actions/Metamask";
import { showModal, hideModal } from '../state/actions/Modal';
import AccountModal from './AccountModal';
import ErrorModal from './ErrorModal';
import ConnectWalletModal from './ConnectWalletModal';
import detectEthereumProvider from '@metamask/detect-provider'
import useIsMountedRef from '../hooks/useIsMountedRef';
import { truncateAddress, capitalize } from '../utils/Utils';
import Config from '../Config';
import { FaBookOpen, FaDiscord, FaInfoCircle } from "react-icons/fa";
import { formatTwoNonZeroDigits } from '../utils/Utils';
import { AiOutlineEllipsis } from "react-icons/ai";
import { useIsMobile } from '../hooks/useIsMobile';
import DelegateModal from './DelegateModal';
import { EmptyDelegates } from '../constants/Contracts';


const NavBar = props => {
  const { networkId, provider, balance, address, modalType, delegates } = props;
  const isMountedRef = useIsMountedRef();
  const isCorrectNetwork = Config.mainNetChainId === networkId;
  const hasDelegates = delegates !== EmptyDelegates;
  const addressRef = useRef();
  const modalTypeRef = useRef();
  const isMobile = useIsMobile();
  const isThetaWallet = Boolean(window.ethereum && window.ethereum.isThetaWallet);

  useEffect(() => {
    addressRef.current = address;
    modalTypeRef.current = modalType;
  })

  useEffect(() => {
    if (!provider || !window.ethereum) return;

    const handleAccountsChanged = (accounts) => {
      const account = accounts[0];

      store.dispatch(setAddress(account));

      if (modalTypeRef.current === 'connect') {
        store.dispatch(showModal('connect'));
      }

      store.dispatch(fetchDelegates(account));
      store.dispatch(fetchBalance(account));
    };

    const handleChainChanged = (chainId) => {
      store.dispatch(setNetworkId(chainId));

      const isCorrectNetwork = chainId === Config.mainNetChainId;

      if (
        (modalTypeRef.current === 'connect' ||
          modalTypeRef.current === 'account') &&
        !isCorrectNetwork
      ) {
        store.dispatch(showModal('networkErr'));
      }

      if (
        modalTypeRef.current === 'networkErr' &&
        isCorrectNetwork
      ) {
        if (addressRef.current == null) {
          store.dispatch(showModal('connect'));
        } else {
          store.dispatch(hideModal());
        }
      }
    };

    window.ethereum.on('accountsChanged', handleAccountsChanged);
    window.ethereum.on('chainChanged', handleChainChanged);

    return () => {
      window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      window.ethereum.removeListener('chainChanged', handleChainChanged);
    };
  }, [provider]);


  useEffect(() => {
    checkProvider();

    async function checkProvider() {
      const ethProvider = await detectEthereumProvider()
      if (!isMountedRef.current) return;
      if (ethProvider) {
        store.dispatch(setProvider(ethProvider));
        console.log('Ethereum successfully detected!')

        const chainId = await ethProvider.request({
          method: 'eth_chainId'
        })
        store.dispatch(setNetworkId(chainId));
      } else {
        // if (provider) setProvider(null);
        console.error('Please install MetaMask!')
      }
    }
  }, [isMountedRef])

  useEffect(() => {
    if (!provider || !isMobile || !isCorrectNetwork) return;
    const fetchAccounts = async () => {
      store.dispatch(setIsConnecting(true));
      try {
        const accounts = await provider.request({
          method: 'eth_requestAccounts'
        })
        if (!isMountedRef.current) return;
        store.dispatch(setAddress(accounts[0]));
        store.dispatch(fetchDelegates(accounts[0]))
        store.dispatch(fetchBalance(accounts[0]));
      } catch (e) {
        store.dispatch(setIsConnecting(false));
      }
    }

    fetchAccounts();
  }, [provider, isCorrectNetwork, isMobile, isMountedRef])

  return <>
    <div className="nav-bar">
      <div className="nav-bar__logo">
        <Link to="/" className="theta-logo"></Link>
        {isMobile && <>
          <div className="nav-bar__navs--network">{Config.defaultThetaChainID}</div>
          <div className="nav-bar__navs--empty"></div>
          <DropDown />
        </>}
      </div>
      <div className="nav-bar__navs">
        {!isMobile && <div className="nav-bar__navs--network">{Config.defaultThetaChainID}</div>}
        <div className="nav-bar__navs--account">
          {!provider && <div className="account__connect" onClick={() => store.dispatch(showModal('connect'))}>Connect Wallet</div>}
          {provider && (isCorrectNetwork ? (address == null ?
            <div className="account__connect" onClick={() => store.dispatch(showModal('connect'))}>Connect Wallet</div> :
            <>
              <div className="account__balance">{formatTwoNonZeroDigits(balance)} Votes</div>
              {!hasDelegates && isMobile && isThetaWallet && <div className="account__info" onClick={() => store.dispatch(showModal('delegate'))}>Delegate</div>}
              <div className="account__info" onClick={() => store.dispatch(showModal('account'))}> {truncateAddress(address)}</div>
            </>) : <div className='account__error' onClick={() => store.dispatch(showModal('networkErr'))}>Wrong Network</div>)}
        </div>
        {!isMobile && <DropDown />}
      </div>
    </div>
    {modalType === 'connect' && <ConnectWalletModal onClose={() => store.dispatch(hideModal())} />}
    {modalType === 'account' && <AccountModal onClose={() => store.dispatch(hideModal())} />}
    {modalType === 'networkErr' && <ErrorModal onClose={() => store.dispatch(hideModal())} title="Wrong Network" content={<WrongNetworkContent />} />}
    {modalType === 'delegate' && <DelegateModal onClose={() => store.dispatch(hideModal())} />}
  </>
}

const DropDown = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isExpanded && ref.current && !ref.current.contains(e.target)) {
        setIsExpanded(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isExpanded]);

  return <div ref={ref} >
    <div className="nav-bar__navs--ellipsis" onClick={() => setIsExpanded(!isExpanded)} >
      <AiOutlineEllipsis />
    </div>
    {isExpanded && <div className="drop-down">
      <a className="drop-down__row" href="https://www.thetatoken.org"
        target="_blank" rel="noopener noreferrer">
        <div className="drop-down__row--title">About</div>
        <div className="drop-down__row--icon"><FaInfoCircle /></div>
      </a>
      <a className="drop-down__row" href="https://discord.gg/vCXJd5YKDt"
        target="_blank" rel="noopener noreferrer">
        <div className="drop-down__row--title">Discord</div>
        <div className="drop-down__row--icon"><FaDiscord /></div>
      </a>
      <a className="drop-down__row" href="https://docs.thetatoken.org/"
        target="_blank" rel="noopener noreferrer">
        <div className="drop-down__row--title">Docs</div>
        <div className="drop-down__row--icon"><FaBookOpen /></div>
      </a>
    </div>}
  </div>
}

const _WrongNetworkContent = (props) => {
  const { provider } = props;
  const handleSwitch = async () => {
    try {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: Config.mainNetChainId }],
      });
    } catch (e) {
      if (e.code === 4902) {
        try {
          await provider.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: Config.mainNetChainId,
                chainName: `Theta ${capitalize(Config.defaultThetaChainID)}`,
                rpcUrls: [Config.rpcUrl],
                blockExplorerUrls: [Config.explorerUrl],
                nativeCurrency: {
                  symbol: 'TFUEL',
                  decimals: 18
                }
              }
            ]
          })
        } catch (err) {
          console.log(err);
        }
      }
    }
  }
  return <div className='model-network-err'>
    <div className='model-network-err__title'>Please connect to Theta {capitalize(Config.defaultThetaChainID)} network.</div>
    <div className='model-network-err__button' onClick={handleSwitch}>
      Theta {capitalize(Config.defaultThetaChainID)}
    </div>
  </div>
}
const mapStateToPropsErrNetwork = state => ({
  provider: state.metamask.provider
});

const WrongNetworkContent = connect(mapStateToPropsErrNetwork)(_WrongNetworkContent);

const mapStateToProps = state => ({
  networkId: state.metamask.networkId,
  provider: state.metamask.provider,
  address: state.metamask.address,
  balance: state.metamask.balance,
  isConnected: state.metamask.isConnected,
  isFetchingBalances: state.metamask.isFetchingBalances,
  modalType: state.modal.type,
  isConnecting: state.metamask.isConnecting,
  delegates: state.metamask.delegates
});

export default connect(mapStateToProps)(NavBar);